import React, { useState, useEffect } from "react"
import PropTypes from 'prop-types'
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"

//i18n
import { withTranslation } from "react-i18next"
// Redux
import { connect } from "react-redux"
import { withRouter, Link } from "react-router-dom"

// users
import avatar2 from "../../../assets/images/users/24X7RETAIL.png"
import { useHistory } from 'react-router-dom';

const ProfileMenu = props => {
  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState(false)

  const [username, setusername] = useState("")
  const [company, setcompany] = useState("")
  const [location, setlocation] = useState("")
  const [usrImg, setusrImg] = useState(avatar2);
  const [userPath, setuserPath] = useState("");
  const [isUserImage, setIsUserImage] = useState(true)

  let history = useHistory();

  useEffect(async () => {
    if (localStorage.getItem("authUser")) {
      const obj = JSON.parse(localStorage.getItem("authUser"))
      //console.log(obj)
      setusername(obj[0])
      setlocation(obj[4])
      setcompany(obj[6])
      /* Changed by : Madhura Liyanage
         Changed On : 30/11/2022
         Reason : Changed all image storage/accessing location to media server
      */
      //---------Beginning of change ---------------------------------------------------------------------------------------------------------------

      setusrImg(`${window.Links.MediaServer + localStorage.getItem("Serial")}/images/user/${obj[1]}`)
      //---------End of change ---------------------------------------------------------------------------------------------------------------


      try {
        const response = await fetch(`${window.Links.MediaServer + localStorage.getItem("Serial")}/images/user/${obj[1]}`);

        // Check if the response is ok (status code 200)
        if (!response.ok) {
          setIsUserImage(false)
        }
      } catch (error) {

      }


    }
  }, [localStorage.getItem("Serial")])


  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item "
          id="page-header-user-dropdown"
          tag="button"
        >
          <img
            className="rounded-circle header-profile-user"
            src={isUserImage ? usrImg : avatar2}
            alt="Header Avatar"
          />
          <span className="d-none d-xl-inline-block ms-2 me-1">{username}</span>
          <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          <DropdownItem tag="a" href="#" disabled>
            <i className="bx bx-building-house font-size-16 align-middle me-1" />
            {company}
          </DropdownItem>
          <DropdownItem tag="a" href="#" disabled>
            <i className="bx bx-store font-size-16 align-middle me-1" />
            {location}
          </DropdownItem>
          {/*<DropdownItem tag="a" href="#">
            <span className="badge bg-success float-end">11</span>
            <i className="bx bx-wrench font-size-16 align-middle me-1"/>
            {props.t("Settings")}
        </DropdownItem>*/}
          <DropdownItem onClick={() => {
            history.push("/Profile");
          }}>
            {" "}
            <i className="bx bx-user font-size-16 align-middle me-1" />
            {props.t("Profile")}{" "}
          </DropdownItem>
          <DropdownItem tag="a" onClick={() => {
            localStorage.setItem("authPark", "true")
            history.push("/auth-lock-screen");
          }}>
            <i className="bx bx-lock-open font-size-16 align-middle me-1" />
            {props.t("Lock screen")}
          </DropdownItem>
          <DropdownItem tag="a" onClick={() => {
            history.push("/my-reports");
          }}>
            <i className="bx bx-file font-size-16 align-middle me-1" />
            {props.t("Reports")}
          </DropdownItem>
          {/* <DropdownItem tag="a" href="auth-lock-screen" onClick={() => {
            localStorage.setItem("authPark", "true")
          }}>
            <i className="bx bx-lock-open font-size-16 align-middle me-1" />
            {props.t("Lock screen")}
          </DropdownItem> */}
          <div className="dropdown-divider" />
          <Link to="/logout" className="dropdown-item" onClick={() => {
            localStorage.clear();
          }}>
            <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger" />
            <span>{props.t("Logout")}</span>
          </Link>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  )
}

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any
}

const mapStatetoProps = state => {
  const { error, success } = state.Profile
  return { error, success }
}

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(ProfileMenu))
)
